import { render, staticRenderFns } from "./BrandClumManage.vue?vue&type=template&id=66db00af"
import script from "./BrandClumManage.vue?vue&type=script&lang=js"
export * from "./BrandClumManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports